import(/* webpackMode: "eager", webpackExports: ["PrismicNextImage"] */ "/opt/build/repo/node_modules/@prismicio/next/dist/PrismicNextImage.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicNextLink"] */ "/opt/build/repo/node_modules/@prismicio/next/dist/PrismicNextLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicPreviewClient"] */ "/opt/build/repo/node_modules/@prismicio/next/dist/PrismicPreviewClient.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicToolbar"] */ "/opt/build/repo/node_modules/@prismicio/react/dist/PrismicToolbar.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/BlogContent/assets/mobblog.jpg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/BlogContent/assets/static-dek.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/BlogContent/assets/tab.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/SharedLinksWithDate.jsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/SideBar/SideNavDropdownLink.jsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/StyledButton.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/StyledHeader/NavContainer.jsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/slices-layout/FooterLinkList/index.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/slices/About/index.jsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/slices/Awards/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/slices/Blogs/components/BlogsGrid.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/slices/CaseStats1/components/Stats2.jsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/slices/Contact/components/form.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/slices/ContactWithMap/components/contactForm.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/slices/Features/components/feature-1/FeatureItemsBlock.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/slices/Features/components/feature-2/ItemCardsBlock.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/slices/Features/components/feature-3/Feature3ItemsBlock.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/slices/Features/components/feature-4/Feature4TilesBlock.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/slices/Hero/variants/home-hero/index.jsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/slices/Hero/variants/main.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/slices/Intro/IntroSection.jsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/slices/PersonalInjuryAttorneys/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/slices/PracticeAreas/components/practice-areas-content.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/slices/PracticeAreas/variants/practice-area2.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/slices/PracticeAreas/variants/practice-area3.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/slices/Questions/components/QuestionBlocks.jsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/slices/Reviews/index.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/slices/RichText/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/slices/Testimonials/components/testimonies.jsx");
